import {Component} from '@angular/core';

@Component({
  selector: 'app-content-wrapper',
  imports: [],
  template: `
    <div class="mx-auto w-full max-w-(--breakpoint-2xl) min-h-screen">
      <ng-content></ng-content>
    </div>
  `,
})
export class ContentWrapperComponent {}
